// Add "Industrial Sensors Products" link to Navigation Menu & Browse All Products Section (TE Sensors)
// https://www.wrike.com/open.htm?id=1641907077
export const Industrial_Sensors_Products_ID = 14670;

// Show Engineering Kits based on this ticket https://www.wrike.com/open.htm?id=1642659080
// new request for this https://www.wrike.com/open.htm?id=1694483761
// 定義不該出現的 definition ID
export const excludedDefinitionIds: number[] = [];

export const buttonHoverStyling = {
    '&:hover': {
        backgroundColor: '#FFFFFF',
        borderBottom: '4px solid #e5673e',
        boxSizing: 'border-box',
    },
};
